import List from 'containers/JobListings/List';
import Create from 'containers/JobListings/Create';
import Show from 'containers/JobListings/Show';

export default { List, Create, Show };
